import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Link, useLocation } from 'react-router-dom'

import { administrationEntitiesNav } from 'modulesCommon/Navigation/consts'

import { INavProps } from './Nav.props'

import './Nav.scss'

export const Nav: FC<INavProps> = ({ navs, isSubNav = false }) => {
  const location = useLocation()

  return (
    <ul className={cn('nav navigation-menu', { 'nav--subnav': isSubNav })}>
      {navs.map((item, index) => {
        const isAdminTab =
          item.label.includes('Admin') &&
          administrationEntitiesNav.some(({ value }) => location.pathname.includes(value))

        return (
          <li
            key={item.label}
            className={cn('nav-item', {
              active: isAdminTab || location.pathname.includes(item.value)
            })}
          >
            <Link to={item.value} state={{loadingType: 'redirect'}} className="nav-link nav-item-link" >
              <b>{item.label}</b>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

